import { ChangeDetectionStrategy, Component, ElementRef, effect, inject, viewChild } from '@angular/core';

import { Auth } from '../service/auth';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,

  template: `
    @if (showSignIn()) {
      <section #loginSection></section>
    } @else {
      <section class="spin-container">
        <div class="spinner spin-1"></div>
        <div class="spinner spin-2"></div>
        <div class="spinner spin-3"></div>
      </section>
    }
  `,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        justify-content: space-around;
        height: 80vh;
      }
    `,
  ],
})
export class LoginPage {
  readonly auth = inject(Auth);
  place = viewChild<ElementRef<HTMLButtonElement>>('loginSection');

  showSignIn = this.auth.showSignIn;

  constructor() {
    effect(() => {
      if (!this.showSignIn()) {
        return;
      }

      const place = this.place();
      if (place) {
        google.accounts.id.renderButton(place.nativeElement, {
          theme: 'outline',
          size: 'large',
          width: 100,
          type: 'standard',
          shape: 'pill',
        });
        // google.accounts.id.prompt();
      }
    });
  }

  // Handle the Google sign-in response (JWT token)
  handleCredentialResponse(response: google.accounts.id.CredentialResponse) {
    // Use NgZone to ensure Angular is aware of changes
    console.log(response);
  }
}
